
import { ChartBar, Instagram, Linkedin } from "lucide-react";
import { useLocation, Link } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isFAQPage = location.pathname === "/faq";

  return (
    <footer className={`${isFAQPage ? 'bg-surface' : 'bg-primary'} ${isFAQPage ? 'text-primary' : 'text-white'} mt-8 py-16`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <Link to="/">
                <img 
                  src={isFAQPage 
                    ? "/lovable-uploads/ebba3bd6-6f73-4dd8-af55-81ad7b9c4ff9.png"
                    : "/lovable-uploads/04906258-8b98-445e-984f-70363bcb3025.png"
                  } 
                  alt="planniFi" 
                  className="h-6"
                />
              </Link>
            </div>
            <p className={`${isFAQPage ? 'text-secondary' : 'text-accent'} text-sm`}>
              The all-in-one media planning, budgeting, and forecasting platform.
            </p>
          </div>
          
          <div className="col-span-1 md:col-span-3 grid grid-cols-3 gap-6 md:gap-12">
            <div>
              <h3 className="font-medium mb-4 text-sm md:text-base">Product</h3>
              <ul className={`space-y-3 ${isFAQPage ? 'text-secondary' : 'text-accent'} text-xs md:text-sm`}>
                <li><Link to="/solutions" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Solutions</Link></li>
                <li><Link to="/pricing" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Pricing</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-medium mb-4 text-sm md:text-base">Resources</h3>
              <ul className={`space-y-3 ${isFAQPage ? 'text-secondary' : 'text-accent'} text-xs md:text-sm`}>
                <li><Link to="/blog" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Blog</Link></li>
                <li><Link to="/faq" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>FAQ</Link></li>
                <li><Link to="/privacy-policy" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Privacy Policy</Link></li>
                <li><Link to="/terms-of-service" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Terms of Service</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-medium mb-4 text-sm md:text-base">Company</h3>
              <ul className={`space-y-3 ${isFAQPage ? 'text-secondary' : 'text-accent'} text-xs md:text-sm`}>
                <li><Link to="/company" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>About</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className={`border-t ${isFAQPage ? 'border-primary/10' : 'border-white/10'} mt-16 pt-8 ${isFAQPage ? 'text-secondary' : 'text-accent'} text-xs md:text-sm`}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p>© 2025 planniFi. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-3">
                <span className="text-xs">Follow us:</span>
                <a href="https://www.instagram.com/tryplannifi/" target="_blank" rel="noopener noreferrer" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>
                  <Instagram size={16} />
                </a>
                <a href="https://www.linkedin.com/company/plannifi/" target="_blank" rel="noopener noreferrer" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>
                  <Linkedin size={16} />
                </a>
              </div>
              <Link to="/privacy-policy" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Privacy Policy</Link>
              <Link to="/terms-of-service" className={`hover:${isFAQPage ? 'text-primary' : 'text-white'} transition-colors`}>Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
